import { Helmet } from "react-helmet"
import CaseStudy, {
  CASE_STUDY_TYPES,
} from "../../../components/case-study/CaseStudy"
import Header from "../../../components/Header"
import Layout from "../../../components/Layout"
import ThumbnailImage from "../../../images/case-study/khaleej-times/thumbnail.png"

export function Index() {
  return (
    <Layout
      title="Khaleej Times Event Marketing Transformation – Premagic AI Platform"
      description="How Khaleej Times scaled their event marketing strategy in the UAE with AI-driven photo distribution, personalized audience interaction, and media engagement powered by Premagic."
      metaImage={ThumbnailImage}
      keywords={[
        "Khaleej Times case study, UAE media event, Dubai newspaper events, Middle East media technology, Arabic media engagement, Gulf media events, UAE journalism events, Middle East news events, Dubai media conference, Arab media innovation, Gulf newspaper technology, UAE media networking, Middle East press events, regional media solutions, Dubai media industry, AI event marketing",
      ]}
      breadcrumbs={[
        { name: "Home", url: "/" },
        { name: "Case Studies", url: "/case-study/" },
        { name: "Khaleej Times", url: "/case-study/khaleejtimes/" },
      ]}
    >
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Article",
            "headline": "Khaleej Times Event Marketing Transformation - Premagic AI Platform",
            "description": "How Khaleej Times scaled their event marketing strategy in the UAE with AI-driven photo distribution, personalized audience interaction, and media engagement powered by Premagic.",
            "image": "https://premagic.com" + ThumbnailImage,
            "author": {
              "@type": "Organization",
              "name": "Premagic",
            },
            "publisher": {
              "@type": "Organization",
              "name": "Premagic",
              "logo": {
                "@type": "ImageObject",
                "url": "https://premagic.com/icons/icon-144x144.png",
              },
            },
            "datePublished": "2024-01-15",
            "dateModified": "2025-01-15",
          })}
        </script>
      </Helmet>
      <Header />
      <CaseStudy type={CASE_STUDY_TYPES.KHALEEJ_TIMES} />
    </Layout>
  )
}

export default Index
